import styled from 'styled-components';

export const RouterWrapper = styled.div`
  font-size: 14px;
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: row-reverse;
  flex-grow: 1;
  overflow: hidden;
  padding: 0 5px;
  z-index: 0;
`;

export const StyledLoader = styled.div`
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;

  .ant-image {
    height: 80px;
    width: 50px;
  }
`;
